import { render } from "./Campuses.vue?vue&type=template&id=05fa5373"
import script from "./Campuses.vue?vue&type=script&lang=js"
export * from "./Campuses.vue?vue&type=script&lang=js"

import "./Campuses.vue?vue&type=style&index=0&id=05fa5373&lang=scss"

import exportComponent from "/codebuild/output/src3853179034/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__